import axios from "axios";

export default function getAllRuleSuggestions() {
    // const fetchOptions = {
    //     method: 'POST'
    // }

    return dispatch => {
        let url = `https://us-central1-fantasy-football-fyg.cloudfunctions.net/get-all-rule-suggestions`;
        return axios.post(url,{})
                     .then(res => {
                            dispatch({
                                type: "get_rules_suc",
                                payload: res.data
                            })
                     }).catch(error => {
                            console.log(error);
                     });
    }
}


